import { useEffect } from "react";
import Button from "components/atoms/Button";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import TableLoadingWrapper from "components/templates/TableLoadingWrapper";
import { StyledTableCell, StyledTableRow } from "components/templates/Tables";
import { Table, TableRow, TableBody, TableHead, TableContainer, Tooltip, } from "@mui/material";
import { MODAL, modalActions } from "redux/slices/modal";
import DynamicService from "services/dynamics.service";
import InfoIcon from "@mui/icons-material/Info";
import BlockComponent from "components/organisms/BlockComponent/BlockComponent";

export default function AlMasar() {
    const dispatch = useAppDispatch();
    const al_masar = useAppSelector((state) => state.dynamics.al_masar);
    const loading = useAppSelector((state) => state.dynamics.loading);

    function capitalizeFirstLetter(str: any) {
        return str[0].toUpperCase() + str.slice(1);
    }

    useEffect(() => {
        DynamicService.getAlMasar();
    }, []);

    return (
        <TableContainer>
            <Table
                aria-label="customized table"
                sx={{
                    minWidth: "100%",
                    borderSpacing: "0 10px",
                    borderBottomWidth: "0px",
                    borderCollapse: "separate",
                }}>
                <TableLoadingWrapper
                    coloumns={4}
                    loading={loading}
                    length={al_masar?.length}
                    message="No Al Masar are available">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Name</StyledTableCell>
                            <StyledTableCell>Net Prices</StyledTableCell>
                            <StyledTableCell>Is Active</StyledTableCell>
                            <BlockComponent permission={"dynamics:edit"}>
                                <StyledTableCell align="center">Action</StyledTableCell>
                            </BlockComponent>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {al_masar.map((item: any, i: number) => (
                            <StyledTableRow key={i + 1}>
                                <StyledTableCell>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                        }}>
                                        <div style={{ width: "100px" }}>
                                            {capitalizeFirstLetter(item?.text)}
                                        </div>
                                        <Tooltip arrow title={item.description}>
                                            <InfoIcon style={{ color: "grey", fontSize: "20px", cursor: 'pointer' }} />
                                        </Tooltip>
                                    </div>
                                </StyledTableCell>
                                <StyledTableCell>{item?.price}</StyledTableCell>
                                <StyledTableCell>{item?.is_active ? "Active" : "Inactive"}</StyledTableCell>
                                <StyledTableCell align="center">
                                    <BlockComponent permission={"dynamics:edit"}>
                                        <Button
                                            size="small"
                                            variant="text"
                                            onClick={() =>
                                                dispatch(
                                                    modalActions.openModal({
                                                        type: MODAL.UPDATE_AL_MASAR,
                                                        data: {
                                                            id: item?._id,
                                                            info: item
                                                        },
                                                        width: "500px",
                                                    })
                                                )
                                            }>
                                            Edit
                                        </Button>
                                    </BlockComponent>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </TableLoadingWrapper>
            </Table>
        </TableContainer>
    );
}
